import {DateFormatEnum} from 'presentation/constants';
import {TelemedicineEnum} from 'presentation/modules/booking/shared/constants/telemedicineEnum';
import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';
import {useMediaQueries} from 'presentation/pages';

import {formatDateWithWeekday, getAppointmentHistoryBookingType} from 'presentation/utils';
import {useTheme} from 'styled-components';
import {buildContentHistoryList} from '../../utils/buildContentHistoryList';
import {UseAppointmentsHistoryCardProps} from './types';
import {useHistoryTheme} from 'presentation/modules/myAppointments/hooks/useHistoryTheme';

export function useAppointmentsHistoryCard({
	appointment,
	handleGoToDetails,
}: UseAppointmentsHistoryCardProps) {
	const {clinic, date, number, typeAttendance} = appointment;
	const {colors} = useTheme();
	const {isLaptop} = useMediaQueries();

	const bookingType = getAppointmentHistoryBookingType({
		telemedicine: clinic.telemedicine,
		typeAttendance: appointment.typeAttendance,
	});

	const {iconName, variant} = useHistoryTheme({
		historyFilter: bookingType,
	});

	const isTelemedicine = clinic.telemedicine === TelemedicineEnum.IS_TELEMEDICINE;
	const isEmergency = typeAttendance === TypeAttendance.EMERGENCY;

	const goToAppointmentDetails = () => {
		const params = isEmergency ? appointment?.appointmentIdPublic : String(number);
		handleGoToDetails(params);
	};

	const {formatted} = formatDateWithWeekday(date, DateFormatEnum.DATE_FORMAT_9);

	const appointmentCardInfos = buildContentHistoryList({
		colors,
		appointment,
	});

	return {
		colors,
		isLaptop,
		iconName,
		variant,
		isTelemedicine,
		isEmergency,
		goToAppointmentDetails,
		formatted,
		appointmentCardInfos,
		bookingType,
	};
}
